import { createContext, useContext } from 'react';
import type { SpaceThreadTarget } from '../spaces/SpaceThreadContainer';
import type { ConversationThreadTarget } from '../conversations/ConversationThreadContainer';

export type ThreadPopoutTarget =
  | { kind: 'space'; rootId: string; space: SpaceThreadTarget }
  | { kind: 'conversation'; rootId: string; conversation: ConversationThreadTarget };

export interface ThreadPopoutsValue {
  /** This platform can open popout windows (desktop). */
  supported: boolean;
  /** Open (or focus) a thread in its own window. */
  popOut: (target: ThreadPopoutTarget) => void;
  isPoppedOut: (rootId: string) => boolean;
}

export const ThreadPopoutsContext = createContext<ThreadPopoutsValue | null>(null);

/** Null outside the authenticated shell (public pages never pop out). */
export function useThreadPopouts(): ThreadPopoutsValue | null {
  return useContext(ThreadPopoutsContext);
}
